import { App } from "../services/permission-checker";

export class MenuItem {
    path: string;
    title: string;
    icon: string;
    locator: string;
    class: string;
    isAdmin: boolean;
    permissionName: string;
    subMenu?: MenuItem[];

    constructor(path: string, title: string, icon: string, locator: string, cssClass: string, isAdmin: boolean, permissionName: string, subMenu?: MenuItem[]) {
        this.path = path;
        this.title = title;
        this.icon = icon;
        this.locator = locator;
        this.class = cssClass;
        this.isAdmin = isAdmin;
        this.permissionName = permissionName;
        this.subMenu = subMenu;
    }

    isGranted(): boolean {
        return this.permissionName ? App.auth.isGranted(this.permissionName) : false;
    }
}
